// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"54":"modules","191":"moduleB","537":"moduleE","592":"moduleC","602":"moduleD","774":"loginB","900":"moduleA"}[chunkId] + "-legacy." + {"54":"d59283b0","191":"5480fc51","537":"868d141e","592":"c9434843","602":"99b6ef79","774":"54e1aadf","900":"2bf8353f"}[chunkId] + ".js";
};